var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.config
    ? _c(
        "div",
        [
          _c(
            "yxt-checkbox",
            {
              attrs: {
                "true-label": 1,
                "false-label": 0,
                disabled: _vm.disabled,
              },
              model: {
                value: _vm.config.visitorEnabled,
                callback: function ($$v) {
                  _vm.$set(_vm.config, "visitorEnabled", $$v)
                },
                expression: "config.visitorEnabled",
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$t(
                      "pc_kng_upload_label_support_visitor" /** 支持游客访问 */
                    )
                  ) +
                  "\n  "
              ),
            ]
          ),
          _vm.config.visitorEnabled
            ? _c(
                "yxt-button",
                {
                  staticClass: "ml4",
                  attrs: { type: "text", disabled: _vm.disabled },
                  on: { click: _vm.set },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "pc_kng_upload_lbl_visitor_collect" /** 游客信息收集项 */
                      )
                    )
                  ),
                ]
              )
            : _vm._e(),
          _vm.config.visitorEnabled
            ? _c(
                "div",
                [
                  _c(
                    "yxt-radio-group",
                    {
                      staticClass: "ml24",
                      attrs: { direction: "row", disabled: _vm.disabled },
                      model: {
                        value: _vm.config.authType,
                        callback: function ($$v) {
                          _vm.$set(_vm.config, "authType", $$v)
                        },
                        expression: "config.authType",
                      },
                    },
                    [
                      _c("yxt-radio", { attrs: { label: 1 } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "pc_kng_upload_label_wx_login_visitor" /** 游客需微信授权后观看 */
                            )
                          )
                        ),
                      ]),
                      _c("yxt-radio", { attrs: { label: 2 } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "pc_kng_upload_label_mb_login_visitor" /** 游客需手机号+验证码验证后观看 */
                            )
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "yxt-checkbox",
                        {
                          attrs: {
                            "true-label": 1,
                            "false-label": 0,
                            disabled: _vm.disabled,
                          },
                          model: {
                            value: _vm.config.encryptEnabled,
                            callback: function ($$v) {
                              _vm.$set(_vm.config, "encryptEnabled", $$v)
                            },
                            expression: "config.encryptEnabled",
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t(
                                  "pc_kng_upload_label_encrypt_pwd_visitor" /** 加密观看（加密后游客需要输入密码才可观看） */
                                )
                              ) +
                              "\n      "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "ml24 mt8" },
                    [
                      _vm.config.encryptEnabled
                        ? _c("yxt-input", {
                            attrs: {
                              maxlength: "6",
                              placeholder: _vm.$t(
                                "pc_biz_lbl_setsixnumberpwd" /** 请设置6位数字密码 */
                              ),
                              disabled: _vm.disabled,
                            },
                            model: {
                              value: _vm.config.encryptPwd,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "encryptPwd", $$v)
                              },
                              expression: "config.encryptPwd",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("yxtbiz-msg-collector-v2", {
            attrs: { "default-data": _vm.defaultData, visible: _vm.visible },
            on: {
              select: _vm.confirm,
              "update:visible": function ($event) {
                _vm.visible = $event
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }